import createReducer, { ActionCreatorHelper } from 'store/createReducer';
import { UserFilterType } from 'store/models/user';
import { UserDetail } from 'store/models/userDetail';

type FilterValue = string;
type IsLoad = boolean;

// ----------------------- actions -------------------------------------
const SET_IS_LOAD_USERS = 'SET_IS_LOAD_USERS';
const SET_USERS_USERS = 'SET_USERS_USERS';
const SET_FILTER_TYPE_USERS = 'SET_FILTER_TYPE_USERS';
const SET_FILTER_VALUE_USERS = 'SET_FILTER_VALUE_USERS';

interface PayloadTypes {
    [SET_IS_LOAD_USERS]: IsLoad;
    [SET_USERS_USERS]: UserDetail[];
    [SET_FILTER_TYPE_USERS]: UserFilterType;
    [SET_FILTER_VALUE_USERS]: FilterValue;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setLoadUsers = ActionCreator(SET_IS_LOAD_USERS);
export const setUsers = ActionCreator(SET_USERS_USERS);
export const setFilterType = ActionCreator(SET_FILTER_TYPE_USERS);
export const setFilterValue = ActionCreator(SET_FILTER_VALUE_USERS);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface UsersState {
    users: UserDetail[];
    isLoad: IsLoad;
    filterType: UserFilterType;
    filterValue: FilterValue;
}

export const USERS_INITIAL_STATE: UsersState = {
    users: [],
    isLoad: true,
    filterType: UserFilterType.EmployerId,
    filterValue: '',
};

export default createReducer<UsersState, PayloadTypes>(USERS_INITIAL_STATE, {
    [SET_IS_LOAD_USERS]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
    [SET_USERS_USERS]: (state, { payload }) => ({
        ...state,
        users: payload,
    }),
    [SET_FILTER_TYPE_USERS]: (state, { payload }) => ({
        ...state,
        filterType: payload,
    }),
    [SET_FILTER_VALUE_USERS]: (state, { payload }) => ({
        ...state,
        filterValue: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
